import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SocialIcons, useSocialLinks } from "@/components/SocialLinks";

export default function Contact() {
  const social = useSocialLinks();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we'll be in touch");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error("Could not send message");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border border-white/20 px-4 py-4 text-white placeholder:text-white/30 focus:outline-none focus:border-white/60 transition-colors text-sm";

  return (
    <div className="pt-28 lg:pt-36 pb-24 max-w-[1200px] mx-auto px-6 lg:px-12">
      <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-6">Contact</p>
      <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl font-light uppercase tracking-tight mb-16">
        Get in Touch
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
        <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
          <input
            data-testid="contact-name"
            required
            placeholder="Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className={field}
          />
          <input
            data-testid="contact-email"
            required
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className={field}
          />
          <textarea
            data-testid="contact-message"
            required
            rows={6}
            placeholder="Message"
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className={field}
          />
          <button
            data-testid="contact-submit"
            disabled={loading}
            className="bg-white text-black px-10 py-4 font-mono-label text-xs uppercase tracking-luxe hover-invert hover:bg-transparent hover:text-white border border-white disabled:opacity-50"
          >
            {loading ? "Sending…" : "Send Message"}
          </button>
        </form>

        <div className="space-y-10">
          {social.length > 0 && <div data-testid="contact-follow">
            <p className="font-mono-label text-xs uppercase tracking-luxe text-white/40 mb-3">Follow</p>
            <SocialIcons links={social} testPrefix="contact-social" linkClass="hover:text-white" />
          </div>}
        </div>
      </div>
    </div>
  );
}
